<template>
  <div class="content-wrapper">
    <app-overlay-loader v-if="preloader" />

    <form
      ref="form"
      data-url="complaints/commissionComplaintDocuments"
      :class="{ 'loading-opacity': preloader }"
      enctype="multipart/form-data"
    >
      <div class="row mt-3">
        <div class="col-12">
          <h4 class="text-primary">CONVOCATORIA COMISIÓN DE LA QUEJA</h4>
          <div class="form-group row">
            <label for="inputs_name" class="col-sm-3 mb-0">
              {{ $t("Seleccionar comisión") }}
            </label>
            <app-input
              style="border: 1px solid #d6d6d6; border-radius: 10px"
              class="col-sm-9"
              type="multi-select"
              :list="userList"
              :isAnimatedDropdown="true"
              v-model="members"
            />

            <div class="col-12">
              <app-note
                class="mb-primary"
                :show-title="false"
                :notes="['Todos los campos con un (*) son obligatorios.']"
              />
            </div>
            <div class="col-12">
              <h4 class="text-primary">Datos de la reunión</h4>
            </div>
            <div class="col-12">
              <div class="form-group row align-items-center">
                <label for="inputs_name" class="col-sm-3 mb-0">
                  {{ $t("Tipo de comisión") }}
                </label>
                <app-input
                  type="radio-buttons"
                  class="col-sm-9"
                  v-model="inputs.personal_remote"
                  :list="options"
                />
              </div>
            </div>
            <div class="col-12">
              <div
                class="form-group row align-items-center"
                v-if="inputs.personal_remote == 1"
              >
                <label for="inputs_name" class="col-sm-3 mb-0">
                  {{ $t("Link de reunión") }} <b class="text-danger">*</b>
                </label>
                <app-input
                  class="col-sm-9"
                  type="text"
                  v-model="inputs.meeting_link"
                />
              </div>
              <div
                class="form-group row align-items-center"
                v-if="inputs.personal_remote == 0"
              >
                <label for="inputs_name" class="col-sm-3 mb-0">
                  {{ $t("Registrar una dirección") }}
                  <b class="text-danger">*</b>
                </label>
                <app-input
                  class="col-sm-9"
                  type="text"
                  v-model="inputs.meeting_link"
                />
              </div>
            </div>

            <div class="col-12">
              <div class="form-group row align-items-center">
                <label for="inputs_name" class="col-sm-3 mb-0">
                  {{ $t("Fecha y hora de reunión") }}
                  <b class="text-danger">*</b>
                </label>
                <app-input
                  id="inputs_name"
                  class="col-sm-4"
                  type="date"
                  v-model="inputs.meeting_date"
                  :required="true"
                  :placeholder="$t('Agregar fecha')"
                />
                <app-input
                  class="col-sm-2"
                  type="time"
                  :required="true"
                  v-model="inputs.meeting_time"
                  :placeholder="$t('Agregar hora')"
                />
              </div>
            </div>
        
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-12 mt-3">
          <button
            type="submit"
            class="btn btn-primary mr-2"
            @click.prevent="submit"
          >
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {
  axiosGet,
  axiosPost,
} from "../../../../../../../../resources/js/app/helpers/AxiosHelper";
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
export default {
  name: "CommiComplaintDocument",
  mixins: [FormMixin],
  props: {
    id: String,
  },
  data() {
    return {
      preloader: false,
      deleteModal: false,
      selected: "",
      inputs: {},
      userList: [],
      userListSelect: [],
      members: [],
      options: [
        {
          id: "0",
          value: "Presencial",
        },
        {
          id: "1",
          value: "Remota",
        },
      ],
    };
  },
  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      this.loadForm();
    },
    evaluator: function () {
      this.onChange();
    },
  },
  created() {
    this.loadForm();
    this.getData();
  },
  methods: {
    returnPage() {
      window.location.href = `/complaints/commissionComplaintDocuments?tab=Selección%20de%20Miembros%20De%20La%20Comisión%20De%20La%20Queja`;
    },
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      const d = this.inputs.meeting_date;
      this.inputs.meeting_date = [
        d.getFullYear(),
        d.getMonth() + 1,
        d.getDate(),
      ].join("-");
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }

      this.members.forEach((element) => {
        formData.append("members[]", element);
      });
      this.save(formData);

    },
    afterSuccess(res) {
      // this.$toastr.s(res.data.message);
      this.preloader = false;
      this.inputs = res.data.data;
      this.$toastr.s(this.$t("complaint_success"));
      this.returnPage();
    },
    getData() {
      let url = `complaints/areaDirectorComplaintDocuments/${this.$store.state.evaluatorReview.evalTestId}`;
      axiosGet(url).then((response) => {
        this.inputs = response.data;

        if(response.data.meeting_date) {
          let date = new Date(response.data.meeting_date);
          date.setDate(date.getDate() + 1);
          this.inputs.meeting_date = date;
        } else {
          this.inputs.meeting_date = new Date();
        }
      });
      let userUrl = `complaints/areaDirectorComplaintDocuments/userList`;
      axiosGet(userUrl).then((response) => {
        this.userList = response.data;
      });
    },
    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },
    openDeleteModal(fileName) {
      this.selected = fileName;
      this.deleteModal = true;
    },
    confirmed() {
      this.inputs[this.selected] = null;
    },
    cancelled() {
      this.deleteModal = false;
    },
    loadForm() {
      if (this.$store.state.evaluatorReview.evalTest) {
        this.inputs = {
          evalTestId: this.$store.state.evaluatorReview.evalTest.id,
          
        };
      }
    },
  },
};
</script>
<style>
.color_import {
  color: #ff5733;
}
</style>
